import { combineReducers } from 'redux';
import accommodationReducer from './accommodationReducer';
import addonGroupReducer from './addonGroupReducer';
import bookingReducer from './bookingReducer';
import bookingTermsReducer from './bookingTermsReducer';
import dietaryTagsReducer from './dietaryTagsReducer';
import eventReducer from './eventReducer';
import experienceReducer from './experienceReducer';
import integrationsReducer from './integrationsReducer';
import loadingReducer from './loadingReducer';
import messagesReducer from './messagesReducer';
import monthlyAvailabilitiesReducer from './monthlyAvailabilitiesReducer';
import obeeAvailabilitySuggestionsReducer from './obeeAvailabilitySuggestionsReducer';
import obeeBookingReducer from './obeeBookingReducer';
import obeeMultiVenueAvailabilitySuggestionsReducer from './obeeMultiVenueAvailabilitySuggestionsReducer';
import paymentSettingsReducer from './paymentSettingsReducer';
import restaurantReducer from './restaurantReducer';
import restaurantsReducer from './restaurantsReducer';

// App's top-level reducers
const appReducer = combineReducers({
  accommodation: accommodationReducer, // Returns tables for accommodation
  booking: bookingReducer,
  bookingTerms: bookingTermsReducer,
  integrations: integrationsReducer,
  loading: loadingReducer,
  messages: messagesReducer,
  monthlyAvailabilities: monthlyAvailabilitiesReducer,
  obeeAvailabilitySuggestions: obeeAvailabilitySuggestionsReducer,
  obeeMultiVenueAvailabilitySuggestions: obeeMultiVenueAvailabilitySuggestionsReducer,
  obeeBooking: obeeBookingReducer,
  paymentSettings: paymentSettingsReducer,
  restaurant: restaurantReducer,
  restaurants: restaurantsReducer,
  experiences: experienceReducer,
  addonGroups: addonGroupReducer,
  dietaryTags: dietaryTagsReducer,
  event: eventReducer,
});

export default appReducer;
